import React from "react";
const MINI = [{
  initials: "MR",
  quote: "Empecé a vender pizzas el jueves. El viernes ya tenía 8 pedidos confirmados con seña.",
  who: "Marcela R., Gran Buenos Aires"
}, {
  initials: "JP",
  quote: "El Tomo de Ghost Kitchen me cambió todo. Mis smash burgers se agotan cada fin de semana.",
  who: "Juan P., Córdoba"
}, {
  initials: "SV",
  quote: "Los scripts de WhatsApp son oro puro. Antes no sabía cómo pedir la seña. Ahora cierro casi todos los pedidos.",
  who: "Sofía V., Rosario"
}];
export function MiniTestimonials() {
  return <section className="bg-black py-10 px-4" data-id="element-180" data-mp="1g9xxuvn4a7zj">
      <div className="max-w-6xl mx-auto grid gap-4 md:grid-cols-3" data-id="element-181" data-mp="1gbskcee1e85q">
        {MINI.map(t => <figure key={t.initials} className="bg-neutral-950 border border-neutral-800 rounded-xl p-5" data-id="element-182" data-mp="1bgv1yguvamg6">
            <div className="flex items-center gap-3 mb-3" data-id="element-183" data-mp="nrah1sf5lf49">
              <div className="w-10 h-10 rounded-full bg-[#e10600] flex items-center justify-center font-display text-white text-sm" data-id="element-184" data-mp="jqqo711m4xnx">
                {t.initials}
              </div>
              <span className="text-yellow-400 text-sm" data-id="element-185" data-mp="6xgaxoueqar0">⭐⭐⭐⭐⭐</span>
            </div>
            <blockquote className="text-neutral-200 text-sm leading-relaxed" data-id="element-186" data-mp="bp866coid4nh">"{t.quote}"</blockquote>
            <figcaption className="text-neutral-500 text-xs mt-3" data-id="element-187" data-mp="gnro81zzdwak">— {t.who}</figcaption>
          </figure>)}
      </div>
    </section>;
}